<script>
import { getAuthAxiosBackend } from "../helpers/axios"
import ImageResize from 'quill-image-resize-module';
import { VueEditor, Quill } from "vue2-editor";

Quill.register("modules/imageResize", ImageResize);

export default {
    components: { VueEditor },
    props:{
        value: {
            type: String,
            default: ''
        },
        editorToolbar:{
            type: Array,
            default: ()=>{
                return [
                    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                    [{ 'font': [] }],
                    [{'size': ['small', false, 'large']}],
                    ["bold", "italic", "underline", "strike"], // toggled buttons
                    [
                        { align: "" },
                        { align: "center" },
                        { align: "right" },
                        { align: "justify" }
                    ],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                    [{ 'direction': 'rtl' }],
                    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                    ["link", "image", "video"],
                    [{ 'script': 'sub' }, { 'script': 'super' }],
                    ["clean"], // remove formatting button
                    ["blockquote", "code-block"],
                ]
            }
        },
        editorOptions:{
            type: Object,
            default: ()=>{
                return {
                    modules: {
                        imageResize: {},
                    }
                }
            }
        },
        placeholder:{
            placeholder: String,
            default: ''
        },
        disabled:{
            type: Boolean,
            default: false
        },
    },
    emit:['onUploadImage', 'onSuccessUploadImage', 'onErrorUploadImage'],
    data(){
        return {
            content: this.value,
            images: [],
            useHandleImageRemoved: true,
        }
    },
    computed: {
    },
    methods:{
        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
            var formData = new FormData();
            formData.append("image", file);
            this.useHandleImageRemoved = false
            
            this.$emit('onUploadImage',
                getAuthAxiosBackend().post('vue2Editor/uploadImage', formData)
                .then((response)=>{
                    Editor.insertEmbed(cursorLocation, "image", response.data.url);
                    resetUploader();

                    this.useHandleImageRemoved = true
                    
                    this.$emit('onSuccessUploadImage', response)
                    this.images.push(response.data)
                    
                    return response
                })
                .catch((error)=>{
                    this.useHandleImageRemoved = true
                    this.$emit('onErrorUploadImage', error)
                    return error
                })
            )
        },
        handleImageRemoved: function(file) {
            if(!this.useHandleImageRemoved) return
            alert('remove image')

            let image = this.images.find((image)=>image.url == file)
            if(image != null){
                
                alert(image)

                this.$emit('onRemoveImage',
                    getAuthAxiosBackend().delete('vue2Editor/uploadImage/' + image.id )
                    .then((response)=>{

                        this.$emit('onSuccessRemoveImage', response)
                        
                        this.images = this.images.filter((image)=>image.id != image.id)

                        return response;
                    })
                    .catch((error)=>{
                        this.$emit('onErrorRemoveImage', error)
                        return error
                    })
                )
            }
        },
        handleInput() {
            this.$emit('input', this.content)
        },
        reset(){
            this.useHandleImageRemoved = false
            Promise.all([
                this.content = '',
                this.images = []
            ]).then(this.useHandleImageRemoved = false)
        }
    },
    watch: {
        value(val) {
            this.content = val
        },
    },
    created(){

    },
    mounted(){
    }  
}
</script>

<template>
    <vue-editor
        useCustomImageHandler
        @image-added="handleImageAdded"
        @image-removed="handleImageRemoved"
        @input="handleInput"
        v-model="content"

        :editorToolbar="editorToolbar"
        :editorOptions="editorOptions"
        :placeholder="placeholder"
        :disabled="disabled"
    >
    </vue-editor>
</template>